var exports = {
  "I": "x93eb46d8--30ad36--chips",
};

module.exports = exports;
